import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CircularProgress, Box } from "@mui/material";
import { useAuth } from "../context/AuthContext";
import { useLanguage } from "../context/LanguageContext";
import api from "../services/api";

const AuthSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { login } = useAuth();
  const { setLanguage } = useLanguage();

  useEffect(() => {
    const token = searchParams.get("token");

    if (token) {
      localStorage.setItem("token", token);

      api
        .get("/auth/me")
        .then((response) => {
          if (response.data.success) {
            login(token, response.data.user);

            // Sync language preference from user account
            if (response.data.user.language) {
              setLanguage(response.data.user.language);
            }

            navigate("/dashboard");
          }
        })
        .catch((error) => {
          console.error("Failed to fetch user:", error);
          navigate("/login");
        });
    } else {
      navigate("/login");
    }
  }, [searchParams, login, navigate, setLanguage]);

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
    >
      <CircularProgress />
    </Box>
  );
};

export default AuthSuccess;
